import HeartWaveMark from "@/components/ui/HeartWaveMark";

const ITEMS = [
  "Cédula 15510639",
  "Musicoterapia Humanista · IMMH",
  "Saxofón Jazz · CME",
  "Toluca · México",
];

/**
 * Subtle editorial marquee strip — adds rhythm between sections.
 */
export default function CredentialStrip() {
  // Triple-duplicate for seamless loop
  const list = [...ITEMS, ...ITEMS, ...ITEMS];

  return (
    <section
      aria-hidden="true"
      className="relative py-6 md:py-7 bg-editorial-dark text-warm-beige/95 overflow-hidden border-y border-editorial-dark"
    >
      <div className="flex whitespace-nowrap animate-[marquee_38s_linear_infinite] will-change-transform">
        {list.map((label, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-5 px-8 text-[0.78rem] tracking-[0.32em] uppercase"
          >
            {label}
            <HeartWaveMark className="w-4 h-4 text-dusty-rose" strokeWidth={1.3} />
          </span>
        ))}
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>
  );
}
